import ProjectWipGroupsConfigContent from './ProjectWipGroupsConfigContent'

export default ProjectWipGroupsConfigContent
